<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>营销策略</el-breadcrumb-item>
				<el-breadcrumb-item>邮件模板</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.templateType" placeholder="请选择模板类型" filterable style="width:200px">
					<el-option key="" label="请选择模板类型" value=""></el-option>
					<el-option v-for="item in templateTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select> &nbsp;
				<el-select v-model="query.mailConfigId" placeholder="请选择邮箱服务" filterable style="width:200px">
					<el-option key="" label="请选择邮箱服务" value=""></el-option>
					<el-option v-for="item in mailConfigKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select> &nbsp;
                <el-input v-model="query.name" placeholder="请输入模板名称" class="handle-input mr10"></el-input>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="模板名称"></el-table-column>
				<el-table-column prop="templateType" label="模板分组" :formatter="templateTypeFormat"></el-table-column>
				<el-table-column prop="mailConfigId" label="邮箱服务" :formatter="mailConfigIdFormat"></el-table-column>
				<el-table-column prop="batchPush" label="批量推送">
					<template slot-scope="scope">
						{{scope.row.batchPush?"是":"否"}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-message"
                            @click="handleSendTest(scope.$index, scope.row)"
							v-if="controll['send-test']"
                        >测试</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="80%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="模板名称" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="模板类型" prop="templateType">
							<el-select v-model="form.templateType" placeholder="请选择模板类型" filterable style="width:100%">
								<el-option key="" label="请选择模板类型" value=""></el-option>
								<el-option v-for="item in templateTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="邮箱服务" prop="mailConfigId">
							<el-select v-model="form.mailConfigId" placeholder="请选择邮箱服务" filterable style="width:100%" @change="mailConfigChange">
								<el-option key="" label="请选择邮箱服务" value=""></el-option>
								<el-option v-for="item in mailConfigKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-checkbox v-model="form.batchPush" style="margin-top:10px;margin-left:50px" v-if="supportBatch">批量推送</el-checkbox>
					</el-col>
					<el-col :span="12">
						<el-form-item label="标签" prop="tag" v-if="form.batchPush">
							<el-input v-model="form.tag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
                <el-form-item label="内容" prop="content">
					<quill-editor ref="mailTemplateEditor" v-model="form.content" :options="mailTemplateOption"></quill-editor>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchMarketingMailTemplateData, saveMarketingMailTemplate, deleteMarketingMailTemplate, getMarketingMailTemplate, 
getEnumValueKV, sendTest, getApplyCompanyEmailSign, getMailConfigKV, getMarketingMailConfig} from '../../../api/index';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import '../../../assets/css/quill.font.css';
import { quillEditor, Quill } from 'vue-quill-editor';
import {quillRedefine} from 'vue-quill-editor-upload';
import { html } from '../../../utils/html';
Quill.register( 'modules/html', html );

// 自定义字体大小
let fontSizeStyle = Quill.import('attributors/style/size');
fontSizeStyle.whitelist = ['10px', '12px', '16px', '18px', '20px', '30px', '32px'];
Quill.register(fontSizeStyle, true);
 
  // 自定义字体类型
var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif'];
var Font = Quill.import('formats/font');
Font.whitelist = fonts;
Quill.register(Font, true);

export default {
    name: 'market-mail-template',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
			templateTypeKV:[],
			templateCode:1025,
			title:"",
			rules: {
                name: [{ required: true, message:'请输入模板名称', trigger: 'blur' }],
                templateType: [{ required: true, message: '请选择模板类型', trigger: 'blur' }],
				mailConfigId: [{ required: true, message: '请选择邮箱服务', trigger: 'blur' }],
				content: [{ required: true, message: '请输入模板内容', trigger: 'blur' }]
            },
			emailSign:"",
			imgPrefix:"/image",
			mailConfigKV:[],
			supportBatch:false,
			controll:{}
        };
    },
	components: {
		quillEditor,
		quillRedefine
	},
    created() {
		this.controll = getControll("market-mail-template");
		let ckey = localStorage.getItem('ms_ckey');
		this.mailTemplateOption = quillRedefine({
			// 图片上传的设置
			uploadConfig: {
				action: this.imgPrefix + "/upload/" + ckey + "/20",  // 邮件图片地址
				res: (respnse) => {
					return this.imgPrefix + respnse.data
				},
				methods: 'POST',  // 可选参数 图片上传方式  默认为post
				name: 'img',  // 可选参数 文件的参数名 默认为img
				size: 4096,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
				accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
				placeholder: '邮件图片',  // 可选参数 富文本框内的提示语
			},
			modules:{
				html:html
			},
			toolOptions:[
				['bold', 'italic', 'underline', 'strike'],   // 加粗，斜体，下划线，删除线
				['blockquote', 'code-block'],                //引用，代码块
				[{ 'list': 'ordered' }, { 'list': 'bullet' }], // 有序列表，无序列表
				[{ 'script': 'sub' }, { 'script': 'super' }], // 下角标，上角标
				[{ 'indent': '-1' }, { 'indent': '+1' }],     // 缩进
				[{ 'direction': 'rtl' }],                      // 文字输入方向
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 标题
				[{ 'size': ['small', false, 'large', 'huge', '10px', '12px', '16px', '18px', '20px', '30px', '32px']}], // 字体大小
				[{ 'font': [false, 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif'] }], // 字体
				[{ 'color': [] }, { 'background': [] }], // 颜色选择
				[{ 'align': [] }], // 居中
				['clean'], // 清除样式,
				['link', 'image', 'video']// 上传图片、上传视频
			]
		});
        this.getData();
		this.getEnumValue();
		this.getEMailSign();
		this.getMailConfig();
    },
    methods: {
		getEMailSign() {
			getApplyCompanyEmailSign().then(res => {
				if (res.code == 0) {
					this.emailSign = res.data;
				} else {
					this.$message.error("获取邮件签名失败！" + res.message);
				}
			});
		},
		getMailConfig() {
			getMailConfigKV().then(res => {
				if (res.code == 0) {
					this.mailConfigKV = res.data;
				} else {
					this.$message.error("获取邮箱服务失败！" + res.message);
				}
			});
		},
		getEnumValue() {
			getEnumValueKV(this.templateCode).then(res => {
				if (res.code == 0) {
					this.templateTypeKV = res.data;
				} else {
					this.$message.error("获取模板类型失败！" + res.message);
				}
			});
		},
		templateTypeFormat(row, column, cellValue){
			let index = this.templateTypeKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.templateTypeKV[index].value;
		},
		mailConfigIdFormat(row, column, cellValue) {
			let index = this.mailConfigKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.mailConfigKV[index].value;
		},
        // 获取数据
        getData() {
            fetchMarketingMailTemplateData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMarketingMailTemplate([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMarketingMailTemplate(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.supportBatch = false;
			this.$set(this.form, 'batchPush', 0)
			if (!(this.emailSign == undefined || this.emailSign == "")) {
				this.form.content = this.emailSign;
			}
			this.editVisible = true;
		},
		handleSendTest(index, row) {
			this.$confirm('确定要测试该邮件吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					sendTest(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('发送测试成功, 请测试接收邮箱查看邮件效果');
							this.getData();
						} else {
							this.$message.error(`发送测试失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			this.supportBatch = false;
			getMarketingMailTemplate(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.supportBatch = res.data["batchPush"];
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveMarketingMailTemplate(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		// 邮箱配置变更
		mailConfigChange(val) {
			if (val == undefined || val == "") {
				return;
			}
			getMarketingMailConfig(val).then(res => {
				if (res.code == 0) {
					this.supportBatch = res.data["supportBatch"];
				} else {
					this.$message.error(`获取邮箱配置信息失败！` + res.message);
				}
			});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
